import { N100, N400 } from '@atlaskit/theme/colors';
import styled from 'styled-components';
export const Label = styled.label `
  box-sizing: 'border-box';
  border-bottom-width: 1px;
  border-bottom-color: ${N400};
  font-size: 12px;
  cursor: pointer;
  font-weight: ${({ fontWeight }) => fontWeight};

  color: ${({ isSelected, selectedColor }) => isSelected ? (selectedColor ? selectedColor : N400) : N100};
  border-bottom-style: ${({ isSelected, borderBottomStyle }) => isSelected ? (borderBottomStyle ? borderBottomStyle : 'solid') : 'none'};
`;
//# sourceMappingURL=label.js.map